import { createElement } from 'react';
import { Link } from 'expo-router';
import { View } from 'react-native';

import type { SearchToolResultChip } from '@/lib/chat/search-tool-results';

type ChatSearchResultChipsProps = {
  chips: SearchToolResultChip[];
};

export function ChatSearchResultChips({ chips }: ChatSearchResultChipsProps) {
  if (chips.length === 0) {
    return null;
  }

  return (
    <View className="mt-1 flex flex-row flex-wrap gap-1.5">
      {chips.map((chip) =>
        createElement(Link, {
          key: chip.id,
          href: chip.href,
          className: 'chat-context-result-chip',
          children: chip.title,
        }),
      )}
    </View>
  );
}
